import React from 'react';
import { Container, Typography, Box } from '@mui/material';
import UserInfo from '../components/UserInfo';

const UserTest: React.FC = () => {
  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Typography variant="h4" component="h1" gutterBottom>
        User Provisioning Test
      </Typography>
      
      <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
        This page tests the automatic user provisioning functionality. 
        When you authenticate with MSAL, the system should automatically create 
        a user record in the database if it doesn't exist.
      </Typography>

      <Box sx={{ mb: 3 }}>
        <UserInfo />
      </Box>

      <Typography variant="h6" gutterBottom>
        How it works:
      </Typography>
      <Typography variant="body2" component="div">
        <ol>
          <li>You authenticate via MSAL (Azure AD)</li>
          <li>The backend receives your access token</li>
          <li>Azure AD middleware validates the token and extracts user claims</li>
          <li>User provisioning dependency checks if you exist in the database</li>
          <li>If not found, automatically creates a new user record</li>
          <li>Updates your last login timestamp</li>
          <li>Returns your database user record for API operations</li>
        </ol>
      </Typography>
    </Container>
  );
};

export default UserTest;